import { render, staticRenderFns } from "./PhCalendar.vue?vue&type=template&id=058779c8"
import script from "./PhCalendar.vue?vue&type=script&lang=js"
export * from "./PhCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports